import { render } from "./App.vue?vue&type=template&id=05997ab5&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=05997ab5&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=05997ab5&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05997ab5"]])

export default __exports__